import { Link } from "@tanstack/react-router";
import { Logo } from "@/components/brand/logo";
import { Button } from "@/components/ui/button";

// Rendered by TanStack Router whenever no route matches. Keeping the
// destination as "/" lets the existing root guard route the user to the
// appropriate dashboard, or to /login if they aren't authed.
export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted p-6">
      <div className="w-full max-w-sm rounded-lg border bg-white p-6 shadow-xs text-center">
        <div className="mb-4 flex justify-center">
          <Logo variant="lockup-vertical" height={64} />
        </div>
        <h1 className="text-xl font-semibold tracking-tight">Page not found</h1>
        <p className="mt-2 text-sm text-foreground/80">
          The page you’re looking for doesn’t exist or has moved.
        </p>
        <div className="mt-6 flex justify-center gap-2">
          <Button asChild variant="outline">
            <Link to="/">Go home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
